import { window } from '../../../../globals';
import useFetchContributorLimit from '../../../../hooks/api/orgLimits/useContributorLimit';

/**
 * Hook to fetch and calculate the contributor limit status.
 */
export const useContributorLimit = () => {
  const { data: value, isLoading } = useFetchContributorLimit(window?.user?.organizationId ?? 0);

  const isContributorsUnlimited = value?.unlimited === true;
  const isAtContributorLimit = !isContributorsUnlimited &&
    value?.usage === value?.max;
  const isOverContributorLimit = !isContributorsUnlimited &&
    !!value?.usage &&
    value?.usage > value?.max;
  return {
    value,
    isLoading,
    isAtContributorLimit,
    isOverContributorLimit,
    isContributorsUnlimited,
  };
};
